<div class="tr"
     [ngClass]="{
       'selected': isSelected,
       'locked': route.isBlockedByUser,
       'routes-table-summary-row tr-summary': isSummaryRow
     }"
     (click)="onRowClick.emit({route: route, event: $event})"
     (dblclick)="onRowDoubleClick.emit({route: route, event: $event})"
     cdkDropList
     [id]="dropListId"
     [cdkDropListConnectedTo]="allPanelIds"
     [cdkDropListSortingDisabled]="true"
     [cdkDropListDisabled]="route.isBlockedByUser || isSummaryRow"
     (cdkDropListDropped)="onDrop.emit({route: route, event: $event})"
     cdkDrag
     [cdkDragDisabled]="route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted || isSummaryRow"
     [cdkDragData]="route">

            <!-- Drag Preview -->
            <div *cdkDragPreview class="tr drag-preview routes-table-drag-preview">
              <div class="td col-id">
                {{ route.name ? route.name : 'Route' | translate }} {{ route.resource?.allocationName || route.resource?.vehicleName || route.planningResource?.name }}
              </div>
              <div class="td col-jobs-count" *ngIf="route.serviceIdList">
                {{ route.serviceIdList?.length }} <span translate>Services</span>
              </div>
            </div>

            <!-- Placeholder -->
            <div *cdkDragPlaceholder class="tr drag-placeholder"></div>

            <!-- Merged Sticky Column: Drag Handle + Checkbox + Eye + Lock + ID/Name -->
            <div class="td col-id sticky-col">
              <div class="index-border" [style.background-color]="route.color"></div>

              <div class="layout-row layout-align-start-center gap-5 full-height" style="width: 100%; margin-left: 14px;">

                <!-- Lock and Eye Stacked Vertically (Always shown on both standard and summary rows) -->
                <div layout="column" layout-align="center center" class="gap-1 lock-eye-vertical" (click)="$event.stopPropagation()">
                  <!-- Lock Button (Top) -->
                  <bringoz-button type="tertiary"
                                  size="fit"
                                  (onClick)="onToggleLocked.emit(route); $event.stopPropagation()">
                    <bringoz-icon [iconName]="route.isBlockedByUser ? 'lock' : 'lock-outline'" classSize="lg" fill="#484848"></bringoz-icon>
                  </bringoz-button>

                  <!-- Eye Button (Bottom) -->
                  <bringoz-button type="tertiary"
                                  size="fit"
                                  (onClick)="onToggleVisible.emit({route: route, isVisible: isVisible}); $event.stopPropagation()">
                    <bringoz-icon iconName="eye" classSize="lg" [fill]="isVisible ? '#266AFF' : '#484848'"></bringoz-icon>
                  </bringoz-button>
                </div>

                <!-- Drag handle (Only for non-summary rows) -->
                <div *ngIf="!isSummaryRow" cdkDragHandle class="layout-row layout-align-start-center" (click)="$event.stopPropagation()">
                  <bringoz-icon iconName="drag" class="secondary-100 pointer" [ngClass]="{disabled: route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted}"></bringoz-icon>
                </div>

                <!-- Back Arrow (Only for summary rows) -->
                <bringoz-button *ngIf="isSummaryRow"
                                type="tertiary"
                                size="fit"
                                (onClick)="onRowClick.emit({route: route, event: $event}); $event.stopPropagation()">
                  <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
                </bringoz-button>

                <!-- Checkbox (Always show except for Resource view or Summary Row) -->
                <app-bringoz-checkbox *ngIf="!isResourceView && !isSummaryRow"
                                      [isChecked]="excludeMode ? !isSelected : isSelected"
                                      (clickEvent)="onToggleSelected.emit({route: route, isSelected: !isSelected}); $event.stopPropagation()"
                                      (click)="$event.stopPropagation()"
                                      (dblclick)="$event.stopPropagation()">
                </app-bringoz-checkbox>

                <!-- Route Title Link -->
                <div class="flex layout-row clickable gap-5 text-ellipsis"
                     [class.align-items-center]="isResourceView"
                     (click)="onSelectRouteResource.emit({route: route, event: $event}); $event.stopPropagation()">
                  <span class="flex br-body-1 text-ellipsis font-weight-600"
                        [appBringozTooltip]="route?.name ? route?.name : (route?.resource?.allocationName || route?.resource?.vehicleName || route?.planningResource?.name)"
                        ngbTooltip>
                    {{ route?.name ? route?.name : 'Route' | translate }} {{ route?.resource?.allocationName || route?.resource?.vehicleName || route?.planningResource?.name }}
                  </span>
                  <span id="route-resource-arrow">
                    ▾
                  </span>
                </div>

              </div>

            </div>

            <!-- Route ID -->
            <div *ngIf="settings?.columns?.id" class="td col-route-id">
              <div class="flex layout-row"
                   (mouseenter)="isShowCopyBtn=true"
                   (mouseleave)="isShowCopyBtn=false"
                   (dblclick)="$event.stopPropagation()">
                <app-bringoz-state-link class="text-ellipsis"
                                        [state]="'planning-route'"
                                        [params]="{id: route.id}"
                                        [permission]="'routes.list'"
                                        [text]="route.id">
                </app-bringoz-state-link>
                <app-text-copy-button [isShowCopyBtn]="isShowCopyBtn"
                                      [text]="route.id">
                </app-text-copy-button>
              </div>
            </div>

            <!-- Status -->
            <div *ngIf="settings?.columns?.status" class="td col-status gap-5">
              <app-bringoz-status-tag [status]="route.status" isSmall="true"></app-bringoz-status-tag>
            </div>

            <!-- Agent -->
            <div *ngIf="settings?.columns?.agent" class="td col-agent gap-5">
              <app-agent-itinerary-link class="text-ellipsis"
                                        [linkToAgentView]="true"
                                        [agent]="route.agentReference"
                                        [isShowCopyButton]="true">
              </app-agent-itinerary-link>
              <bringoz-icon *ngIf="route.status === 'Unassigned' && route.agentReference"
                            iconName="assistant"
                            classSize="sm"
                            [ngbTooltip]="'ROUTES_VIEW_ROUTES_SETTINGS.associatedAgentDescription' | translate"
                            openDelay="300">
              </bringoz-icon>
            </div>

            <!-- Vehicle -->
            <div *ngIf="settings?.columns?.vehicle" class="td col-vehicle gap-5">
              <bringoz-icon [iconName]="route.vehicleType?.toLowerCase() || 'truck'" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.vehicle?.name || '---' }}</span>
            </div>

            <!-- Time Window -->
            <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window gap-5">
              <bringoz-icon iconName="time-window-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route | timeWindow }}</span>
            </div>

            <!-- Duration -->
            <div *ngIf="settings?.columns?.duration" class="td col-duration gap-5">
              <bringoz-icon iconName="timer-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totalTimeSec | bringozTimeConvert }}</span>
            </div>

            <!-- Distance -->
            <div *ngIf="settings?.columns?.distance" class="td col-distance gap-5">
              <bringoz-icon iconName="distance" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totalDistanceMeter | bringozDistance:'---':true }}</span>
            </div>

            <!-- Services -->
            <div *ngIf="settings?.columns?.services" class="td col-services gap-5">
              <bringoz-icon iconName="package-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.serviceIdList?.length || 0 }}</span>
            </div>

            <!-- Stops Count -->
            <div *ngIf="settings?.columns?.tasksCount" class="td col-tasks-count gap-5">
              <bringoz-icon iconName="location-pin-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.taskIdListExt?.length || 0 }}</span>
            </div>

            <!-- Pickup Stops -->
            <div *ngIf="settings?.columns?.pickupStops" class="td col-pickup-stops gap-5">
              <app-task-purpose [purpose]="TaskPurposeType.Pickup" [firstLetterOnly]="true"></app-task-purpose>
              <span class="br-body-1 text-ellipsis">{{ stopsCount?.pickup || 0 }}</span>
            </div>

            <!-- Destination Stops -->
            <div *ngIf="settings?.columns?.destinationStops" class="td col-destination-stops gap-5">
              <app-task-purpose [purpose]="TaskPurposeType.Dropoff" [firstLetterOnly]="true"></app-task-purpose>
              <span class="br-body-1 text-ellipsis">{{ stopsCount?.destination || 0 }}</span>
            </div>

            <!-- Pro Number -->
            <div *ngIf="settings?.columns?.proNumber" class="td col-pro-number gap-5">
              <bringoz-icon iconName="hash" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <span *ngIf="!proNumbers?.length"> --- </span>
              <app-bringoz-items-list-display *ngIf="proNumbers?.length" [items]="proNumbers" [maxItems]="1" [isTransparentBackground]="true" [canCopy]="true">
              </app-bringoz-items-list-display>
            </div>

            <!-- Relations -->
            <div *ngIf="settings?.columns?.relations" class="td col-relations">
              <app-task-relations-indicator [relations]="relations" (onClick)="onRelationsClick($event)">
              </app-task-relations-indicator>
            </div>

            <!-- Reference IDs -->
            <div *ngIf="settings?.columns?.referenceIds" class="td col-reference-ids gap-5 text-ellipsis">
              <bringoz-icon iconName="hash" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-items-list-display *ngIf="!!route.referenceIds?.length" class="flex"
                                              [items]="route.referenceIds"
                                              [maxItems]="1"
                                              [isTransparentBackground]="true">
              </app-bringoz-items-list-display>
              <span *ngIf="!route.referenceIds?.length">---</span>
            </div>

            <!-- Accounts -->
            <div *ngIf="settings?.columns?.accounts" class="td col-accounts gap-5">
              <bringoz-icon iconName="account" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis clickable" [ngbTooltip]="accountsTooltip" tooltipClass="routes-table-list-accounts-tooltip" container="body" (click)="$event.stopPropagation()">
                {{ route.accountIds?.length === 1 ? ('X_ACCOUNT' | translate: {length: route.accountIds.length}) : ('X_ACCOUNTS' | translate: {length: route.accountIds.length}) }}
              </span>

              <ng-template #accountsTooltip>
                <div class="col" style="min-width: 450px;">
                  <div class="flex layout-row">
                    <div class="flex br-caption-1" style="text-align: start;"><span translate>Account Name</span>:</div>
                    <div class="flex br-caption-1" style="text-align: start;"><span translate>Address</span>:</div>
                    <div class="flex br-caption-1" style="text-align: start;"><span translate>Account External ID</span>:</div>
                    <div class="flex-15 br-caption-1" style="text-align: start;"><span translate>Pallets</span>:</div>
                  </div>

                  <div class="flex layout-row" *ngFor="let reference of accountReferences">
                    <div class="flex" style="text-align: start;">
                      {{reference.name}}
                    </div>
                    <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                      {{ reference.address ? (reference.address | bringozAddressCity) : '---'}}
                    </div>
                    <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                      {{reference.externalId || '---' }}
                    </div>
                    <div class="flex-15 layout-row layout-align-start-center gap-5">
                      {{reference.pallets | number: '1.0-2'}}
                      <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <!-- Account External IDs -->
            <div *ngIf="settings?.columns?.accountsExternalIds" class="td col-accounts-external-ids gap-5">
              <bringoz-icon iconName="hash" classSize="sm" openDelay="300"></bringoz-icon>
              <app-bringoz-items-list-display *ngIf="route.accountReferences?.length" class="flex"
                                              [itemsList]="{list: route?.accountReferences, displayKey: 'externalId'}"
                                              [maxItems]="6">
              </app-bringoz-items-list-display>
              <span *ngIf="!route.accountReferences?.length">---</span>
            </div>

            <!-- Picking Hour -->
            <div *ngIf="settings?.columns?.pickingHour" class="td col-picking-hour gap-5">
              <bringoz-icon iconName="depot" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ pickingTime | bringozTime:'time' }}</span>
            </div>

            <!-- Trips (Sequence) -->
            <div *ngIf="settings?.columns?.trips" class="td col-trips gap-5">
              <bringoz-icon iconName="route" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.sequenceInRouteGroup || '--' }}</span>
            </div>

            <!-- Skills -->
            <div *ngIf="settings?.columns?.skills" class="td col-skills gap-5">
              <bringoz-icon iconName="tag-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span *ngIf="!route.requiredSkills?.length" class="br-body-1 text-ellipsis">---</span>
              <app-skill-tags class="flex" [skillsIds]="route.requiredSkills" [limit]="1"></app-skill-tags>
            </div>

            <!-- Tags -->
            <div *ngIf="settings?.columns?.tags" class="td col-tags gap-5">
              <bringoz-icon iconName="label-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <app-bringoz-tags *ngIf="route.planningResource?.tags?.length"
                                class="flex"
                                [tags]="route.planningResource.tags"
                                [maxTags]="1"
                                [isShowTagDescriptions]="true">
              </app-bringoz-tags>
              <span *ngIf="!route.planningResource?.tags?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Resource -->
            <div *ngIf="settings?.columns?.resource" class="td col-vehicle gap-5">
              <bringoz-icon [iconName]="route.vehicleType?.toLowerCase() || 'truck'" classSize="sm" openDelay="300"></bringoz-icon>
              <div class="flex layout-row text-ellipsis gap-5">
                <app-bringoz-state-link *ngIf="route.planningResource?.mainLogisticsVehicleReference"
                                        class="text-ellipsis"
                                        [state]="'logistics-vehicle.vehicle-profile'"
                                        [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.name"
                                        openDelay="300" triggers="hover"
                                        [params]="{id: route.planningResource.mainLogisticsVehicleReference.id}"
                                        [text]="route.planningResource.mainLogisticsVehicleReference.name">
                </app-bringoz-state-link>

                <app-bringoz-state-link *ngIf="route.planningResource?.attachedLogisticsVehicleReferences?.length"
                                        class="text-ellipsis"
                                        [state]="'logistics-vehicle.vehicle-profile'"
                                        [ngbTooltip]="route.planningResource.attachedLogisticsVehicleReferences[0].name"
                                        openDelay="300" triggers="hover"
                                        [params]="{id: route.planningResource.attachedLogisticsVehicleReferences[0].id}"
                                        [text]="route.planningResource.attachedLogisticsVehicleReferences[0].name">
                </app-bringoz-state-link>
              </div>
            </div>

            <!-- Plate Number -->
            <div *ngIf="settings?.columns?.plateNumber" class="td col-plate-number gap-5">
              <bringoz-icon iconName="plate-number" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis"
                    *ngIf="!!route.planningResource?.mainLogisticsVehicleReference?.licensePlateNumber"
                    [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.licensePlateNumber"
                    openDelay="300" triggers="hover">
                {{ route.planningResource.mainLogisticsVehicleReference.licensePlateNumber }}
              </span>
              <span *ngIf="!route.planningResource?.mainLogisticsVehicleReference?.licensePlateNumber" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Assistants -->
            <div *ngIf="settings?.columns?.assistant" class="td col-assistant gap-5">
              <bringoz-icon iconName="assistant" classSize="sm" [ngbTooltip]="'Assistant' | translate"></bringoz-icon>
              <app-bringoz-items-link-list *ngIf="route.assistantAgentReferences?.length"
                                           style="max-width: 80%;"
                                           [textEllipsis]="true"
                                           [state]="'agent.agent-profile'"
                                           [items]="route.assistantAgentReferences"
                                           [maxDisplay]="1"
                                           [permission]="'drivers.get'">
              </app-bringoz-items-link-list>
              <span *ngIf="!route.assistantAgentReferences?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <!-- Price (Courier Price) -->
            <div *ngIf="settings?.columns?.price" class="td col-price gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.courierPrice | bringozPrice: '---' }}</span>
            </div>

            <!-- Value (Total Price) -->
            <div *ngIf="settings?.columns?.value" class="td col-value gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totalPrice | bringozPrice: '---' }}</span>
            </div>

            <!-- Progress -->
            <div *ngIf="settings?.columns?.progress" class="td col-progress gap-5">
              <app-bringoz-capacity-bar class="flex"
                                        [value]="(route.stats?.finished * 100) / route.stats?.total"
                                        [unit]="'%'"
                                        [showValue]="true"
                                        [isDisableSeverity]="true">
              </app-bringoz-capacity-bar>
            </div>

            <!-- Loads -->
            <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalLoad | bringozWeight:true:'---':false:2 }}</span>
            </div>

            <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalVolume | bringozVolume:true:'---' }}</span>
            </div>

            <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages gap-5">
              <bringoz-icon iconName="package-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span *ngIf="route.totalLoad?.numberOfPackages > 0; else emptyLoad" class="br-body-1 text-ellipsis">
                {{ (route.totalLoad.numberOfPackages === 1 ? 'X_PACKAGE' : 'X_PACKAGES') | translate: { sum: route.totalLoad.numberOfPackages } }}
              </span>
            </div>

            <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm" openDelay="300"></bringoz-icon>
              <span *ngIf="route.totalLoad?.numberOfPallets > 0; else emptyLoad" class="br-body-1 text-ellipsis">
                {{ (route.totalLoad.numberOfPallets === 1 ? 'X_PALLET' : 'X_PALLETS') | translate: { sum: (route.totalLoad.numberOfPallets | number: '1.0-2') } }}
              </span>
            </div>

            <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots gap-5">
              <bringoz-icon iconName="spot" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">
                {{ (route.totals?.totalSpots === 1 ? 'X_SPOT' : 'X_SPOTS') | translate: { sum: route.totals?.totalSpots || 0 } }}
              </span>
            </div>

            <div *ngIf="settings?.load?.value" class="td col-load col-load-value gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.courierPrice | bringozPrice: '---' }}</span>
            </div>

            <!-- Capacities -->
            <div *ngIf="settings?.capacity?.weight" class="td col-capacity col-capacity-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="route.maxLoad?.weight; else unlimitedWeight"
                                        [value]="(route.totals?.totalLoad / route.maxLoad.weight) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: route.totals?.totalLoad, max: route.maxLoad.weight } | capacityTooltipPipe:weightUnit"
                                        [tooltipClass]="weightSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedWeight>
                <div [ngbTooltip]="{ current: route.totals?.totalLoad, max: route.maxLoad?.weight } | capacityTooltipPipe:weightUnit" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.volume" class="td col-capacity col-capacity-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="volumeCapacity; else unlimitedVolume"
                                        [value]="(route.totals?.totalVolume / volumeCapacity) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: route.totals?.totalVolume, max: volumeCapacity } | capacityTooltipPipe:volumeUnit"
                                        [tooltipClass]="volumeSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedVolume>
                <div [ngbTooltip]="{ current: route.totals?.totalVolume, max: volumeCapacity } | capacityTooltipPipe:volumeUnit" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.pallets" class="td col-capacity col-capacity-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm" fill="#484848" openDelay="300"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="route.maxLoad?.numberOfPallets; else unlimitedPallets"
                                        [value]="(route.totals?.totalPallets / route.maxLoad.numberOfPallets) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="{ current: route.totals?.totalPallets, max: route.maxLoad.numberOfPallets } | capacityTooltipPipe"
                                        [tooltipClass]="palletsSeverity">
              </app-bringoz-capacity-bar>

              <ng-template #unlimitedPallets>
                <div [ngbTooltip]="{ current: route.totals?.totalPallets, max: route.maxLoad?.numberOfPallets } | capacityTooltipPipe" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;" translate>UNLIMITED</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <!-- Dynamic Metadata Columns -->
            <ng-container *ngIf="settings?.metadata">
              <ng-container *ngFor="let metaData of settings.metadata">
                <div *ngIf="metaData.enabled" class="td col-meta-data gap-5">
                  <span class="br-body-1 text-ellipsis">
                    {{ route.metaData | bringozMetaDataDisplay: metaData }}
                  </span>
                </div>
              </ng-container>
            </ng-container>

            <!-- Drill Down Right Arrow -->
            <div *ngIf="!isSummaryRow" class="td col-actions sticky-col-right layout-row layout-align-center-center">
              <bringoz-button type="tertiary" size="fit" (onClick)="onDrillDownClick.emit({route: route, event: $event}); $event.stopPropagation()">
                <bringoz-icon iconName="arrow-right" classSize="lg" fill="#484848"></bringoz-icon>
              </bringoz-button>
            </div>

          </div>

<ng-template #emptyLoad>
  <span class="br-body-1 text-ellipsis">---</span>
</ng-template>
